package com.karyadina.ui.screens.pomodorotimer.presentation

import com.karyadina.model.PomodoroConfig
import com.karyadina.model.PomodoroSession
import com.karyadina.model.PomodoroStats
import com.karyadina.model.SessionType
import com.karyadina.model.TimerState
import com.karyadina.service.StudyPlannerServiceImpl

data class PromodorTimerUiState(
    val isLoading: Boolean = false,

    // State Cards
    val taskName: String = "Test",
    val value: String? = null,

    //Timer status
    val timerState: TimerState = TimerState.IDLE,
    val remainingTime: Int = 0,
    val totalTime: Int = 1500, // Default 25 min
    val progress: Float = 1.0f, // circular progress bar

    //Timer Circle
    val remainingSeconds: Int = 0,
    val totalSeconds: Int = 0,
    val sessionType: SessionType = SessionType.FOCUS,
    // Session Type Selector
    val selectedType: SessionType = SessionType.FOCUS,

    // Settings
    val configFocusTime: Int = 25,
    val configShortBreakTime: Int = 5,
    val configLongBreakTime: Int = 15,

    val taskInput: String = "",
    val activeTaskName: String? = null,
    // Data
    val stats: PomodoroStats? = null,
    val config: PomodoroConfig? = null,
    val updateConfig: PomodoroConfig? = null
)

// Evnets
sealed interface PromodorTimerEvent {
    data object Refresh : PromodorTimerEvent

    data class StartSession(val taskName: String) : PromodorTimerEvent
    data object PauseSession : PromodorTimerEvent
    data object ResumeSession : PromodorTimerEvent
    data object StopSession : PromodorTimerEvent

    //task
    data class UpdateTaskInput(val name: String) : PromodorTimerEvent

    // Session Type Selector
    data class SelectSessionType(val type: SessionType) : PromodorTimerEvent

    data object ShowSettings : PromodorTimerEvent
    data object HideSettings : PromodorTimerEvent
    data class UpdateConfig(val config: PomodoroConfig) : PromodorTimerEvent
}


